export default {"src":"/_next/static/media/2FA.d529b608.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};